import {FC, ReactElement} from "react";
import Homepage from "pages/homepage";

const App: FC = (): ReactElement => {
    return (
        <div className={"App"}>
            <Homepage />
        </div>
    );
};

export default App;
